import _en_US from "./lang/en_US";
import _zh_CN from "./lang/zh_CN";
import _register from "./register";
import _format from "./format";
import _realtime from "./realtime";
var exports = {};

/**
 * Created by hustcc on 18/5/20.
 * Contract: i@hust.cc
 */
var __importDefault = exports && exports.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var en_US_1 = __importDefault(_en_US);

var zh_CN_1 = __importDefault(_zh_CN);

var register_1 = _register;
exports.register = register_1.register;
register_1.register("en_US", en_US_1.default);
register_1.register("zh_CN", zh_CN_1.default);
var format_1 = _format;
exports.format = format_1.format;
var realtime_1 = _realtime;
exports.render = realtime_1.render;
exports.cancel = realtime_1.cancel; //# sourceMappingURL=index.js.map

export default exports;
export const __esModule = exports.__esModule,
      register = exports.register,
      format = exports.format,
      render = exports.render,
      cancel = exports.cancel;